import React, { useEffect } from "react";
import { gsap, Elastic } from "gsap";

export default function Section1Figures() {
    useEffect(() => {

      function thousandDelimeter(n) {
        return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");	
      }
      gsap.from('.ouders-numbers-thousand', {
        textContent: 0,
        duration: 2,
        ease: "power3.inOut",
        snap: { textContent: 10 },
        scrollTrigger: '.ouders-numbers-thousand',
        onUpdate: function() {
          this.targets().forEach(target => {
            const val = gsap.getProperty(target, "textContent");
            target.textContent = thousandDelimeter(val);
          });
        }
      })

      gsap.from('.ouders-numbers', {
        textContent: 0,
        duration: 2,
        ease: "power3.inOut",
        snap: { textContent: 1 },
        scrollTrigger: '.ouders-numbers'
      })
      gsap.set('.heart-beating', {scale: 0.8})
      gsap.to('.heart-beating', {scaleX:0.9, scaleY:1.1, ease:Elastic.easeOut, repeat:-1, repeatDelay:0.5})
    }, [])

    return (
        <>

    <path
      style={{
        fill: "none",
      }}
      d="M479.18 1575h169.09v117.08H479.18z"
    />
    <text transform="translate(520.33 1612.248)">
      <tspan
        x={0}
        y={0}
        className="ouders-numbers"
        style={{
          fill: "#522e91",
          fontFamily: "'Sansa'",
          fontWeight: 'bold',
          fontSize: 55,
        }}
      >
        {"7,8"}
      </tspan>
      <tspan
        x={-0.84}
        y={21}
        style={{
          fontFamily: "'Sansa'",
          fontSize: 14,
        }}
        className="text-responsiveness"
      >
        {"rapportcijfer "}
      </tspan>
      <tspan
        x={-18.44}
        y={38}
        style={{
          fontFamily: "'Sansa'",
          fontSize: 14,
        }}
        className="text-responsiveness"
      >
        {"klanttevredenheid"}
      </tspan>
    </text>
    <path
      style={{
        fill: "none",
      }}
      d="M533.1 1730.71h280.2v58.63H533.1z"
    />
    <text transform="translate(622.225 1749.46)">
      <tspan
        x={0}
        y={0}
        className="ouders-numbers-thousand"
        style={{
          fill: "#522e91",
          fontFamily: "'Sansa'",
          fontWeight: 'bold',
          fontSize: 25,
        }}
      >
        {"141230"}
      </tspan>
      <tspan
        x={-8.17}
        y={17}
        style={{
          fontFamily: "'Sansa'",
          fontSize: 14,
        }}
        className="text-responsiveness"
      >
        {"telefoontjes naar "}
      </tspan>
      <tspan
        x={-7.89}
        y={34}
        style={{
          fontFamily: "'Sansa'",
          fontSize: 14,
        }}
        className="text-responsiveness"
      >
        {"Service & Contact"}
      </tspan>
    </text>
    <path
      style={{
        fill: "none",
      }}
      d="M791.91 1555.02H961v93.73H791.91z"
    />
    
    <text transform="translate(853.024 1573.772)">
      <tspan
        x={0}
        y={0}
        className="ouders-numbers"
        style={{
          fill: "#522e91",
          fontFamily: "'Sansa'",
          fontWeight: 'bold',
          fontSize: 25,
        }}
      >
        {"104"}
      </tspan>
      <tspan
        x={-26.62}
        y={17}
        style={{
          fontFamily: "'Sansa'",
          fontSize: 14,
        }}
        className="text-responsiveness"
      >
        {"aanmeldingen "}
      </tspan>
      <tspan
        x={-39.06}
        y={34}
        style={{
          fontFamily: "'Sansa'",
          fontSize: 14,
        }}
        className="text-responsiveness"
      >
        {"Praten met je kind "}
      </tspan>
    </text>
    <path
      style={{
        fill: "none",
      }}
      d="M7.97 1713.77h169.09v67.29H7.97z"
    />
    <text transform="translate(52.094 1732.523)">
      <tspan
        x={0}
        y={0}
        className="ouders-numbers"
        style={{
          fill: "#522e91",
          fontFamily: "'Sansa'",
          fontWeight: 'bold',
          fontSize: 25,
        }}
      >
        {"57,7"}
      </tspan>
      <tspan
        x={80.85}
        y={0}
        style={{
          fill: "#ec008c",
          fontFamily: "'Sansa'",
          fontWeight: 'bold',
          fontSize: 25,
        }}
      />
      <tspan
        x={6.06}
        y={17}
        style={{
          fontFamily: "'Sansa'",
          fontSize: 14,
        }}
        className="text-responsiveness"
      >
        {"maternale "}
      </tspan>
      <tspan
        x={-6.03}
        y={34}
        style={{
          fontFamily: "'Sansa'",
          fontSize: 14,
        }}
        className="text-responsiveness"
      >
        {"kinkhoestprik"}
      </tspan>
    </text>
    
   
    
   
    
    
    
    <path
      style={{
        fill: "#575756",
      }}
      d="m414.72 1680.63 7.22-2.72c.69-.26 1.14-1.09.99-1.86-.15-.79-.83-1.2-1.52-.94l-7.22 2.72c-.69.26-1.14 1.09-.99 1.86.15.8.83 1.2 1.52.94zM414.72 1685.3l7.22-2.72c.69-.26 1.14-1.09.99-1.86-.15-.79-.83-1.2-1.52-.94l-7.22 2.72c-.69.26-1.14 1.09-.99 1.86.15.79.83 1.2 1.52.94zM414.72 1689.96l7.22-2.72c.69-.26 1.14-1.09.99-1.86-.15-.79-.83-1.2-1.52-.94l-7.22 2.72c-.69.26-1.14 1.09-.99 1.86.15.79.83 1.2 1.52.94zM414.72 1694.63l7.22-2.72c.69-.26 1.14-1.09.99-1.86-.15-.79-.83-1.2-1.52-.94l-7.22 2.72c-.69.26-1.14 1.09-.99 1.86.15.79.83 1.2 1.52.94zM414.72 1699.29l7.22-2.72c.69-.26 1.14-1.09.99-1.86-.15-.79-.83-1.2-1.52-.94l-7.22 2.72c-.69.26-1.14 1.09-.99 1.86.15.79.83 1.2 1.52.94z"
    />
    <path
      style={{
        fill: "#522e91",
      }}
      d="m421.49 1677.79-7.32-1.71c-.7-.16-1.15-.94-1.01-1.73.15-.82.84-1.33 1.54-1.16l7.32 1.71c.7.16 1.15.94 1.01 1.73-.15.81-.84 1.32-1.54 1.16zM421.49 1682.48l-7.32-1.71c-.7-.16-1.15-.94-1.01-1.73.15-.82.84-1.33 1.54-1.16l7.32 1.71c.7.16 1.15.94 1.01 1.73-.15.82-.84 1.33-1.54 1.16zM421.49 1687.18l-7.32-1.71c-.7-.16-1.15-.94-1.01-1.73.15-.82.84-1.33 1.54-1.16l7.32 1.71c.7.16 1.15.94 1.01 1.73-.15.82-.84 1.32-1.54 1.16zM421.49 1691.88l-7.32-1.71c-.7-.16-1.15-.94-1.01-1.73.15-.82.84-1.33 1.54-1.16l7.32 1.71c.7.16 1.15.94 1.01 1.73-.15.81-.84 1.32-1.54 1.16zM421.49 1696.57l-7.32-1.71c-.7-.16-1.15-.94-1.01-1.73.15-.82.84-1.33 1.54-1.16l7.32 1.71c.7.16 1.15.94 1.01 1.73-.15.82-.84 1.33-1.54 1.16z"
    />
    <path
      style={{
        fill: "#3c3c3b",
      }}
      d="M440.96 1673.18c.11-5.74-2.77-7.82-7.99-7.4l.07-1.89c6.16-3.28 11.91-1.96 16.32 5.46-1.15 3.91-4.59 5.61-8.4 3.83zM397.22 1648.21c-.03.81-.71 1.44-1.53 1.41-.81-.03-1.45-.71-1.42-1.52.03-.81.71-1.44 1.53-1.41.82.03 1.45.71 1.42 1.52z"
    />
    <path
      style={{
        fill: "#3c3c3b",
      }}
      d="M400.37 1646.53a2.27 2.27 0 0 1-2.36 2.18c-1.26-.05-2.24-1.1-2.19-2.35s1.1-2.23 2.36-2.18c1.26.04 2.24 1.09 2.19 2.35z"
    />
    <path
      style={{
        fill: "#3c3c3b",
      }}
      d="M404.25 1646.47a2.815 2.815 0 0 1-2.92 2.7 2.807 2.807 0 0 1-2.71-2.91 2.815 2.815 0 0 1 2.92-2.7c1.55.05 2.77 1.36 2.71 2.91z"
    />
    <ellipse
      style={{
        fill: "#3c3c3b",
      }}
      cx={405.45}
      cy={1647.94}
      rx={3.09}
      ry={3.08}
    />
    <path
      style={{
        fill: "#3c3c3b",
      }}
      d="M405.86 1650.63a3.083 3.083 0 0 0 2.97 3.19c1.71.06 3.14-1.26 3.21-2.96.06-1.7-1.27-3.13-2.97-3.19a3.08 3.08 0 0 0-3.21 2.96z"
    />
    <path
      style={{
        fill: "#3c3c3b",
      }}
      d="M413.86 1654.86c-.01.39-.1.75-.25 1.1-.27.64-.76 1.17-1.37 1.5-.05.03-.1.06-.17.08-.42.21-.91.31-1.42.29-.54-.02-1.04-.18-1.48-.43a3.06 3.06 0 0 1-1.5-2.76c.01-.35.08-.68.21-.99a3.096 3.096 0 0 1 3-1.97c.33.01.65.07.94.19.8.29 1.44.9 1.78 1.66.19.4.28.85.26 1.33z"
    />
    <path
      style={{
        fill: "#3c3c3b",
      }}
      d="M415.11 1658.7c0 .11-.01.23-.04.34-.1.8-.53 1.48-1.13 1.95-.25.21-.54.36-.85.48-.37.14-.77.21-1.19.2-1.72-.06-3.05-1.5-2.98-3.19.01-.38.1-.75.25-1.08.35-.86 1.08-1.5 1.98-1.76.3-.09.63-.13.97-.12.26.01.5.05.73.12.27.06.52.18.74.32.96.55 1.56 1.58 1.52 2.74z"
    />
    <path
      style={{
        fill: "#f799d1",
      }}
      d="m439.42 1689.29-7.14-.27c0-.97-.12-1.93-.34-2.86-1.04-4.42-4.38-8.16-8.92-10.14-.03-.02-.06-.04-.1-.05-.62-.27-1.26-.51-1.92-.7-.37-.11-.74-.21-1.13-.3a20.78 20.78 0 0 0-3.55-.48h-.24c-1.01-.02-1.99.03-2.95.16-6.37.85-11.56 4.91-13.27 10.31-.29.91-.48 1.86-.56 2.83l-6.84-.26c.38-.95.75-1.88 1.14-2.8 1.68-4.06 3.46-7.71 5.36-10.63.73-1.14 1.06-2.47.98-3.8-.15-2.49.31-3.13 1.68-6.72.55-2.28.37-4.37-1.37-6.85-1.61 1.76-3.45 1.28-4.57 1.82l-.04 1.04c.01 1.08-1.15 1.79-2.27 1.85 0 0-3.22.09-2.92-2.85.06-.66.32-1.3.69-1.87l4.17-6.09s.12-.44.48-1.01c.24-.39.6-.86 1.1-1.27.1-.09.22-.18.33-.25.21-.14.42-.28.67-.4.24-.1-.92-2.45-.64-2.48.58-.08 1.06.1 1.46.41.86.63 1.29 1.79 1.29 1.79s.04 0 .13.01c.3.05 1.13.19 2.23.57.31.1.65.24 1 .39.81.34 1.69.81 2.62 1.44.33.23.68.48 1.02.75.61.5 1.23 1.07 1.84 1.75.36.4.72.85 1.06 1.32.44.6.86 1.25 1.25 1.97.33.59.63 1.22.91 1.9.03.06.05.12.07.19.05.12.1.24.14.36.32.82.6 1.68.84 2.62.24.11.52.21.82.29 1.87.53 4.87.6 7.75.34.68-.05 1.36-.13 2.01-.23.71-.1 1.36-.22 1.97-.35 3.59-.46 6.02.97 7.36 3.16.33.56.6 1.17.8 1.81.27.85.4 1.77.41 2.69.01.26-.04.57-.11.92-.62 3-.3 6.12.99 8.89 1.19 2.52 2.35 5.36 3.35 8.19.35.98.68 1.94.96 2.89z"
    />
    <path
      style={{
        fill: "#522e91",
      }}
      d="m420.1 1668.92-.23 6.05c-1.14-.26-2.33-.42-3.55-.47-.08 0-.16-.01-.24 0l.22-5.72 3.8.14z"
    />
    <path
      style={{
        fill: "#522e91",
      }}
      d="m424.21 1661.12-.17 4.25a5.183 5.183 0 0 1-3.99 4.85c-.44.11-.92.16-1.41.14l-.67-.03c-.61-.02-1.18-.14-1.72-.36-1.99-.79-3.37-2.75-3.29-5.01l.12-3.48.03-.76c.24.11.52.21.82.29 1.87.53 4.87.6 7.75.34.68-.05 1.36-.13 2.01-.23.05-.01.52 0 .52 0z"
    />
    <path
      style={{
        fill: "#3c3c3b",
      }}
      d="m393.6 1684.73 6.26.23c-.28.91-.47 1.85-.55 2.83l-6.84-.26c.38-.95.75-1.88 1.13-2.8zM439.43 1689.29l-7.14-.27c0-.98-.12-1.93-.34-2.86l6.53.24c.33.98.66 1.94.95 2.89z"
    />
    <path
      style={{
        fill: "#522e91",
      }}
      d="M430.95 1705.39a13.883 13.883 0 0 0-12.86-8.61c-5.81 0-10.79 3.56-12.86 8.61h25.72z"
    />
    <path
      style={{
        fill: "#7558a7",
      }}
      d="M686.29 1696.27v16.32c0 1.08-.86 1.96-1.92 1.96h-26.95c-1.06 0-1.93-.88-1.93-1.96v-57.82c0-1.08.86-1.96 1.93-1.96h26.95c1.06 0 1.92.88 1.92 1.96v6.63"
    />
    <path
      style={{
        fill: "#00aeef",
      }}
      d="M682.85 1696.27v9.46h-23.93v-44.59h23.93"
    />
    <path
      style={{
        fill: "#66cef5",
      }}
      d="M658.92 1705.73v-44.59h23.93"
    />

    <path
      style={{
        fill: "#fbcce8",
      }}
      d="m217.2 1694.78-1.24-28.92-30.09-1.45-7.63 30.36c-.29 34.47 1.13 67.39 5.43 97.7h6.95l7.78-94.78-4.5 92.61h7.32c7.7-31.14 13.05-62.98 15.98-95.52z"
    />
    <path
      style={{
        fill: "#fbcce8",
      }}
      d="M236.23 1699.38c-.13-.21-.29-.4-.45-.57l-11.23-31.01-4.69-43.42a8.613 8.613 0 0 0-6.61-6.53l-16.42-3.49-13.88 1.78c-.74.09-1.53.29-2.33.56-6.18 2.1-10.44 7.79-11.03 14.29l-6.19 24.15 8.37 6.75 6.79-18.89 7.3 21.42 30.09 1.45.15 5.3 13.37 27.9c-.7 1.03-1 2.37-.57 3.53-2.37.42-3.14 3.83-2.06 5.76 1.3 2.32 4.24 2.81 6.6 2.15 2.23-.62 4.13-2.34 4.69-4.62.62-2.48-.6-4.54-1.9-6.51z"
    />
    <path
      style={{
        fill: "#fbcce8",
      }}
      d="M191.15 1617.93c0 4.76 12.93 4.76 12.93 0v-12.35h-12.93v12.35z"
    />
    <path
      style={{
        fill: "#ec008c",
      }}
      d="M212.15 1583.16c-.93 3.5-.01 6.78 2.07 7.34 2.08.56 4.52-1.83 5.46-5.32.94-3.5.01-6.78-2.07-7.34-2.08-.56-4.52 1.82-5.46 5.32zM180.76 1585.15c.93 3.5.01 6.78-2.07 7.34-2.08.56-4.52-1.83-5.46-5.32-.93-3.5-.01-6.78 2.07-7.34 2.08-.56 4.53 1.82 5.46 5.32z"
    />
    <path
      style={{
        fill: "#fbcce8",
      }}
      d="M191.72 1610.5c.41.11.82.2 1.22.28 11.39 2.34 22.16-6.21 22.97-17.81l1.53-18.74c0-11.15-8.87-20.42-20.02-20.61-.41-.01-.82-.01-1.23-.01-11.22.01-20.11 9.08-19.9 20.3.14 7.52.73 12.92 1.27 19.42.68 8.12 6.27 15.13 14.16 17.17z"
    />
    <path
      style={{
        fill: "#4b2d90",
      }}
      d="M219.24 1739.66v-60.53l-3.29-13.26-33.3-1.82s-4.41 14.06-6.58 18.46c-8.43 17.11-8.43 58.6-8.43 58.6l51.6-1.45z"
    />
    <path
      style={{
        fill: "#fbcce8",
      }}
      d="m191.75 1689.83 10.25 5.06c2.66 1.32 5.61-1.17 4.76-4.02a9.514 9.514 0 0 0-7.4-6.64l-4.56-.84-23.02-21.51 3.03-12.55c-.5-2.9-1.01-5.81-1.73-8.69-1.02-4.07-1.95-8.21-2.79-12.38-.15.4-.29.81-.42 1.22l-9.38 37.18 31.26 23.17z"
    />
    <path
      style={{
        fill: "#4b2d90",
      }}
      d="m207.43 1616.6 2.89 6.7c1.17 2.73-.76 5.78-3.72 5.89l-1.31.05c-5.83.22-11.24-3.05-13.76-8.31l-2.66-5.56-6.91.89 2.77 11.59c1.25 5.23-.81 9.83-6.17 15.16l2.46 6.78 1.48 14.64 33.45 1.45.64-14.01 3.89-6.65c2.68-4.57 2.76-10.22.21-14.86l-6.75-12.35-6.51-1.41z"
    />
    <path
      style={{
        fill: "#4b2d90",
      }}
      d="m183.67 1657.91 2.19 6.51 30.09 1.44.46-7.95z"
    />
    <path
      style={{
        fill: "#522e91",
      }}
      d="M183.7 1791.39c-.51.62-.97 1.28-1.43 1.86-1.87 2.38-4.05 4.52-6.14 6.72-.36.38-.73.8-1.02 1.25-.4.62-.64 1.29-.48 2 .19.82.92 1.44 1.72 1.7.8.26 1.67.22 2.51.13 1.84-.21 3.68-.68 5.27-1.64 2.37-1.42 2.9-4.27 4.97-5.7.35 1.04 1.61 1.8 2.36.38.99-1.86.79-4.71-.41-6.69h-7.35zM215.2 1800.31c-2.17-2.84-6.13-3.49-9.17-5.37-2.06-1.28-3.56-3.1-4.74-5h-7.48c-.62 1.52-.6 3.44-.24 4.85.27 1.07.82 2.07 1.65 2.82.71.65 2.34 1.31 3.16.45.27-.29.23-.74.16-1.13 2.12 1.35 4.33 2.78 6.62 3.82 2.08.94 4.39 1.38 6.67 1.36.84-.01 1.68-.08 2.5-.21.51-.08 1.12-.29 1.18-.8.03-.29-.14-.56-.31-.79z"
    />
    <path
      style={{
        fill: "#f799d1",
      }}
      d="M206.62 1796.51c.6 0 .8-.81.27-1.09-.29-.15-.57-.32-.85-.49-1.11-.69-2.05-1.54-2.87-2.46h-4.72l2.07 1.78a9.334 9.334 0 0 0 6.1 2.26zM181.56 1796.9c1.63.17 3.22-.58 4.13-1.95l1.12-1.7h-4.54l-1.48 1.7c-.63.72-.18 1.85.77 1.95z"
    />
    <path
      style={{
        fill: "#4b2d90",
      }}
      d="M216.25 1651.72s10.16 7.08 10.16 22.14c0 0-.92 26.71-21.7 28.09l11.54-50.23z"
    />
    <path
      className="heart-beating"
      style={{
        fill: "#fde5f3",
      }}
      d="M217.45 1665.05c-4.08-10.34-12.42 3.06-12.42 3.06s-8.34-13.4-12.42-3.06c-4.36 11.04 12.42 17.42 12.42 17.42s16.77-6.38 12.42-17.42z"
    />
    <path
      style={{
        fill: "#19b6f1",
      }}
      d="M187.07 1556.09c-.1.05-.2.1-.3.13-1.38.46-2.83-.66-4.23-.48-1.83.23-3.73 1.69-5.04 2.89-4.69 4.31-6.49 10.92-7.39 17.23-.87 6.09 1.31 48.2 1.31 48.2s1.93-1.92 2.77-2.56c.79-.6 2.96-1.59 2.96-1.59.91-.09 1.9.95 2.42 1.61.61.79 1.03 1.71 1.42 2.62.94 2.19 1.83 4.24 2.26 6.58.05.28.76 4.17.66 4.18 3.03-.24 7.28-.48 10.32-.72-.31-5.14-.9-10.29-2.08-15.31-.22-.95-.74-1.85-.78-2.83-.22-5.43-.24-5.39-.22-5.71-3.64-1.08-6.64-3.04-9-5.89-1.14-6.16-.83-20.9-.18-25.36 1.39-9.41 5.36-15.85 7.46-14.87 4.04 1.89 8.03 3.7 12.19 5.24 4.98 1.84 8.6 6.46 10.33 11.35 2.29 6.48 2.43 14.27.63 20.88-1.06 3.89-6.23 7.03-8.51 7.96 0 0-.02 6.54 0 8.27 0 0 4.2 1.78 4.94 3.96 1.46 4.33.65 9.84 1.41 14.38 2.93-.51 5.91-.76 8.89-.75-.52 0 1.56-22.45 1.77-24.46.84-7.85 1.48-15.62 1.95-23.52.56-9.31.22-19.14-5.78-26.82-5.19-6.64-13.64-9.42-21.85-9.19-1.65.05-3.28.48-4.73 1.27-1.23.7-2.41 2.67-3.6 3.31z"
    />
    <linearGradient
      id="a"
      gradientUnits="userSpaceOnUse"
      x1={-181.892}
      y1={1390.292}
      x2={-129.853}
      y2={1390.292}
      gradientTransform="rotate(-90 97.649 1426.354)"
    >
      <stop
        offset={0}
        style={{
          stopColor: "#fff",
        }}
      />
      <stop
        offset={0.999}
        style={{
          stopColor: "#f99d31",
        }}
      />
    </linearGradient>
   
    <path
      style={{
        fill: "#00aeef",
      }}
      d="m63.54 1685.52 4.56 4.56 5.56-5.55-6.54-6.54-5.53 5.54"
    />
    <path
      style={{
        fill: "#b7abd3",
      }}
      d="M282.52 1588.18c0 15.39-1.8 26.79-19.13 26.79-16.71 0-20.88-12.48-20.88-27.87s9.35-27.87 20.88-27.87c11.54-.01 19.13 13.55 19.13 28.95zM292.23 1702.09c2.02-2.05 4.88-1.27 6.46.8.05.06.09.12.14.18.95 1.25.6 2.96.05 4.26-.32.74-.62 2.12-.29 2.94.05.03.1.07.17.12l.85.61c.78.56 1.49 1.16 2.19 1.76.66.56.61 1.47.31 2.18-1.76 4.15-8.12 2.18-10.16-.57-2.4-3.21-2.64-9.32.28-12.28zM228.69 1696.96c2.02-2.05 4.88-1.27 6.46.8.05.06.09.12.14.18.95 1.25.6 2.96.05 4.26-.32.74-.62 2.12-.29 2.94.05.03.1.07.17.12l.85.61c.78.56 1.49 1.16 2.19 1.76.66.56.61 1.47.31 2.18-1.76 4.15-8.12 2.18-10.16-.57-2.4-3.21-2.63-9.32.28-12.28z"
    />
    <path
      style={{
        fill: "#4b2d90",
      }}
      d="M284.5 1806.66c.59-.22 1.04-.71 1.35-1.26 1.01-1.85.4-4.24-.92-5.88-1.32-1.64-3.21-2.69-5.06-3.7-2.17-1.19-4.36-2.38-6.72-3.14-2.36-.75-4.93-1.05-7.32-.4-.91 1.51-.59 3.52.37 5s2.45 2.53 3.94 3.46c3.71 2.33 7.69 4.24 11.83 5.66.81.3 1.71.56 2.53.26zM234.5 1803.64c-1.02-.53-1.12-1.35-1.15-2.88-.02-.84.03-1.71.45-2.44.26-.44.63-.79 1.01-1.13 2.35-2.17 4.56-3.52 7.66-4.51 2.36-.75 4.93-1.05 7.32-.4 1.89.51-.46 6.5-1.11 7.27-.77.85-1.68 1.57-2.7 2.11-.53.29-1.09.53-1.65.76-1.16.49-2.33.98-3.56 1.26-1.57.35-4.18.72-5.74.18-.2-.06-.38-.14-.53-.22z"
    />
    <path
      style={{
        fill: "#4b2d90",
      }}
      d="m239.8 1677.83 45.05-2.12v17.56l-3.3 100.14H264.4l-1.81-83.8-2.05 6.08-9.12 77.72h-14.64z"
    />
    <path
      style={{
        fill: "#b7abd3",
      }}
      d="m246.77 1616.69 16.22-3.45 15.28 1.96v13.9h-31.5z"
    />
    <path
      style={{
        fill: "#ffd200",
      }}
      d="m262.99 1624.28 8.87-13.33 1.95 2.19s16.74 5.12 21.1 9.62c7.66 7.91 8.57 37.73 8.57 37.73l-2.93 43.48h-9.87l-1.13-33.5-4.7-17.95v24.18l-45.14 1.41.58-5.18-3.37 8.83-1.4 20.41-10.37-8.1 3.84-32.26s-2.01-30.3 4.33-38.52c3.59-4.65 19.09-9.42 19.09-9.42l2-2.18 8.58 12.59z"
    />
    <path
      style={{
        fill: "#ffd200",
      }}
      d="M294.92 1622.76c-3.97-4.1-18.89-9.3-18.89-9.3l-2.58 13.41-2.28-1.79-8.18 10.84-7.57-11.11-2.61 2.05-3.88-12.01s-12.56 4.5-15.59 8.43c-6.34 8.22-4.33 38.52-4.33 38.52l-3.28 26.89 10.38 5 .82-11.93 3.37-8.83-.58 5.18 45.14-1.41v-24.18l4.7 17.95.96 28.45h10.39l2.59-38.44c-.02.01-.93-29.81-8.58-37.72z"
    />
    <path
      style={{
        fill: "#b7abd3",
      }}
      d="M244.11 1587.17c.94 3.54.01 6.86-2.09 7.42-2.1.56-4.57-1.85-5.52-5.39-.95-3.54-.01-6.86 2.09-7.42 2.1-.56 4.58 1.86 5.52 5.39zM282.27 1587.17c-.94 3.54-.01 6.86 2.09 7.42 2.1.56 4.57-1.85 5.52-5.39.94-3.54.01-6.86-2.09-7.42s-4.58 1.86-5.52 5.39z"
    />
    <path
      style={{
        fill: "#fff",
      }}
      d="M281.6 1568.52v6.85h-.82l.04 18.54c.01 4.72-1.26 9.36-3.69 13.41l-7.16.61-11.61.45-7.41-.38-6.1-6.87v-25.76h-2.56c-.09.8-.15 1.62-.15 2.44v26.4c0 4.84 3.29 9.06 7.97 10.25 8.72 2.21 17.31 2.18 25.77.02 4.66-1.19 7.9-5.42 7.9-10.23v-26.43c.01-3.34-.78-6.5-2.18-9.3z"
    />
    <path
      style={{
        fill: "#fff",
      }}
      d="M272.86 1559.44c7.56-2.48 11.83-.18 11.83 13.04l-.9 21.14-4.14-15.68-3.91-10-25.48 4.97c-2.9.57-5 3.11-5 6.07l-3.11 14.64-3.1-15.8c-5.57-27.24 12.58-24.02 25.76-23 3.24.24 6.2 1.94 8.05 4.62z"
    />
    <path
      style={{
        fill: "none",
      }}
      d="M258.87 1602.56c1.39 2.53 5.17 3.11 8.45 1.3M256.14 1590.35c0 1.75-.84 3.17-1.89 3.17-1.04 0-1.89-1.42-1.89-3.17s.85-3.17 1.89-3.17c1.05 0 1.89 1.42 1.89 3.17zM268.89 1590.35c0-1.75.85-3.17 1.89-3.17s1.89 1.42 1.89 3.17-.85 3.17-1.89 3.17c-1.05.01-1.89-1.41-1.89-3.17z"
    />
    <path
      style={{
        fill: "none",
      }}
      d="M255.04 1592.93c0 .46-.99.84-2.22.84-1.22 0-2.21-.37-2.21-.84 0-.46.99-.83 2.21-.83s2.22.37 2.22.83zM274.34 1592.93c0 .46-.99.84-2.21.84s-2.21-.37-2.21-.84c0-.46.99-.83 2.21-.83s2.21.37 2.21.83z"
    />
    <path
      style={{
        fill: "none",
      }}
      d="M242.14 1577.81v26.4c0 4.84 3.29 9.06 7.97 10.25 8.72 2.21 17.31 2.18 25.77.02 4.66-1.19 7.9-5.42 7.9-10.23"
    />
    <path
      style={{
        fill: "none",
      }}
      d="m242.14 1593.62-3.1-15.8c-5.57-27.24 12.58-24.02 25.76-23 3.25.25 6.21 1.94 8.06 4.63 7.56-2.48 11.83-.18 11.83 13.04l-.9 31.78"
    />
    <path
      style={{
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "#fff",
      }}
      d="M808.28 1568.18s-1.21 66.94-1.64 68.57l-4 49.68-11.96 1c-1.17-16.64-1.07-49.18 0-57.54l-4.41-42.16c-10.8-.23 22.01-19.55 22.01-19.55z"
    />
    <path
      style={{
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "#fff",
      }}
      d="m791.39 1568.85-20.29-3.36-5.44-.9-.27-.05v1.22c-1.94 8.56-4.69 21.99-4.69 21.99l4.51 37.12c-16.87 22.24-26.82 47.29-26.82 47.29l6.25 10.19 34.78-47.89 24.71-65.47-12.74-.14z"
    />
    <path
      style={{
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "#522e91",
      }}
      d="m799.96 1686.42 5.44 3.63c1.05.86 2.34 1.36 3.69 1.43l1.37.06c.61.03 1.14.45 1.31 1.04.24.81-.28 1.64-1.11 1.78l-15.14-.28s-3.58-.72-1.35-7.49l5.79-.17z"
    />
    <path
      style={{
        fill: "#522e91",
      }}
      d="M745.07 1685.07s.52 3.67 3.36 5.3c1.79 1.03 2.27 2.76.91 3.5l-5.68-.9c-.62-.57-.72-.65-1.89-1.96-1.5-1.68-1.79-2.97-2.42-5.13-.73-2.49-1.8-5.09-2.25-6.24 0 0-.95-2.49 3.88-4.3 3.2.54 5.61 4.26 4.09 9.73z"
    />
    <path
      style={{
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "#ffd200",
      }}
      d="m797.63 1512.9 15.68-9.35.35 8.26-10.22 13.33z"
    />
    <path
      style={{
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "#fff",
      }}
      d="m842.95 1524.32-35.74-2.38 16.76-26.05 35.83 2.32c-.39.54 0 0-.61.87l-16.24 25.24z"
    />
    <path
      style={{
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "#522e91",
      }}
      d="m842.52 1524.23-36.74-2.38 15.99-24.85c.36-.56 1.43-1.16 2.02-1.12l34.97 2.27c.32.02.4.23.2.54l-16.44 25.54z"
    />
    <path
      style={{
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "#fff",
      }}
      d="m840.7 1519.84-26.61-1.84 11.54-18.55c.26-.42 1.04-.86 1.46-.83l25.33 1.75c.23.02.29.17.14.4l-11.86 19.07z"
    />
    <path
      style={{
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "#ffd200",
      }}
      d="M789.61 1505.92c19.54.53 29.06 16.83 41.28 29.63 1.12 1.18-2.47-2.01-2.76-.22-3.57 22.43-33.43-13.37-33.43-13.37l-5.09-16.04z"
    />
    <path
      style={{
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "#ffd200",
      }}
      d="m772.57 1535.06-11.27 33.45c13.69-.23 44.21 7.98 48.95-2.16-3.52-26.2-4.58-45.93-16.8-60.44l-16.12-4.33"
    />
    <path
      style={{
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "#baabd3",
      }}
      d="M846.07 1517.19s-8.06 17.22-15.99 22.97c-7.92 5.75-7.45-3.73-6.8-6.24.65-2.51 16.15-18.75 16.15-18.75l6.64 2.02z"
    />
    <path
      style={{
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "#baabd3",
      }}
      d="M842.96 1521.38s9.38-1.95 7.12-7.1c-2.26-5.15-9.71-2.56-10.75.02s3.63 7.08 3.63 7.08z"
    />
    <path
      style={{
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "#7d62ac",
      }}
      d="M810.83 1513.19s14.25-3.53 11.68-8.54-9.82-1.99-10.7.66-.98 7.88-.98 7.88z"
    />
    <path
      style={{
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "#baabd3",
      }}
      d="M805.56 1497.23s-2.27 7.46-4.16 13.65a4.688 4.688 0 0 1-3.53 3.24c-1.68.35-3.42-.23-4.57-1.53-.37-.43-.74-.84-1.08-1.23a6.158 6.158 0 0 1-1.06-6.47c2.35-5.57 6.64-15.71 6.64-15.71l7.76 8.05z"
    />
    <path
      style={{
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "#baabd3",
      }}
      d="M790.43 1468.66c.27-5.07 4.6-8.92 9.67-8.6 5.42.35 12.25.78 17.67 1.13 5.08.32 8.19 4.71 8.71 9.77.62 5.97-.94 18.19-3.15 26.9-1.25 4.91-5.43 9.25-10.5 8.93-5.42-.35-21.39-6.54-22.45-16.32-.8-7.45-.34-14.35.05-21.81z"
    />
    <path
      style={{
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "#522e91",
      }}
      d="M776.69 1480.48s1.42-19.57 10.43-25.02c12.1-7.33 26.75-9.54 38.85 6.07 0 0-4.01 29.89-49.28 18.95z"
    />
    <path
      style={{
        fill: "#522e91",
      }}
      d="M792.26 1464.83s-6.79-29.97-24.04-18.47c-17.26 11.5-1.76 32.21 16.02 31.53 17.77-.68 8.02-13.06 8.02-13.06z"
    />
    <ellipse
      transform="rotate(-18.071 797.496 1487.13)"
      style={{
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "#baabd3",
      }}
      cx={797.66}
      cy={1487.35}
      rx={6.24}
      ry={7.59}
    />
    <path
      style={{
        fill: "#522e91",
      }}
      d="M773.55 1474.65c.98 2.68-.22 5.79-2.3 7.74-2.08 1.95-4.89 2.92-7.67 3.55-2.19.49-4.89 1.26-5.26 3.47-.32 1.9 1.59 3.59 3.51 3.79 1.92.2 3.77-.65 5.52-1.48-.33 2.42-1.78 4.52-2.87 6.71-1.08 2.19-1.81 4.87-.67 7.03 1.79 3.41 6.78 3.29 10.33 1.79.94-.4 1.92-.87 2.93-.72 1.12.16 1.98 1.03 2.76 1.85 2.66 2.83 5.97 5.93 9.82 5.35 3.88-.59 6.17-4.68 7.13-8.48.58-2.3.89-4.75.24-7.04-.72-2.55-2.56-4.63-3.67-7.04-2.62-5.64-.64-13.02 4.44-16.6-.52.22-1.04.44-1.55.66"
    />
    <g id="section-2">
      <path  d="M113.93 1662L66.37 1665.05L64 1643.36L114.53 1639L113.93 1662Z" fill="white"/>
      <path  d="M56 1684.75C56 1671.74 66.55 1661.19 79.56 1661.19C92.58 1661.19 103.12 1671.74 103.12 1684.75C103.12 1697.76 92.57 1708.31 79.56 1708.31C66.55 1708.31 56 1697.76 56 1684.75Z" fill="#FCC98D"/>
      <path  d="M76.569 1657.28C76.429 1655.97 75.919 1655.35 74.819 1655.46C73.719 1655.57 73.339 1656.29 73.479 1657.6L73.519 1657.99C73.659 1659.31 74.169 1659.95 75.279 1659.83C76.379 1659.72 76.759 1658.98 76.619 1657.67L76.569 1657.28Z" fill="#EC008C"/>
      <path  d="M103.989 1652.5L103.129 1652.59L103.379 1655.05L104.209 1654.96C105.109 1654.87 105.299 1654.39 105.209 1653.56C105.119 1652.7 104.819 1652.41 103.989 1652.5Z" fill="#EC008C"/>
      <path  d="M92.2604 1653.71L91.4004 1653.8L91.6504 1656.26L92.4804 1656.17C93.3704 1656.08 93.5704 1655.6 93.4804 1654.77C93.4004 1653.92 93.0904 1653.62 92.2604 1653.71Z" fill="#EC008C"/>
      <path  d="M91.1491 1646.98C91.9991 1646.89 92.2691 1646.44 92.1891 1645.69C92.1091 1644.87 91.7691 1644.68 90.9791 1644.76L90.1191 1644.85L90.3491 1647.06L91.1491 1646.98Z" fill="#EC008C"/>
      <path  d="M112.109 1656.83L112.009 1655.83L112.999 1655.73L113.099 1656.73L112.109 1656.83ZM112.469 1650.74L112.799 1654.89L111.999 1654.97L111.469 1650.84L112.469 1650.74ZM109.719 1657.08L108.7 1657.19L108.169 1652.06L106.41 1652.24L106.319 1651.38L110.859 1650.91L110.95 1651.77L109.189 1651.95L109.719 1657.08ZM104.349 1655.81L103.459 1655.9L103.649 1657.7L102.619 1657.81L101.999 1651.82L104.039 1651.61C105.339 1651.48 106.109 1652.07 106.249 1653.44C106.409 1654.87 105.659 1655.68 104.349 1655.81ZM100.599 1648.94L98.1695 1646.46L97.8595 1646.49L98.1395 1649.19L97.1095 1649.3L96.4895 1643.31L97.5195 1643.2L97.7695 1645.65L98.1195 1645.61L99.9295 1642.94L101.06 1642.82L101.069 1642.88L98.9795 1645.89L101.779 1648.73L101.789 1648.79L100.599 1648.94ZM99.5595 1658.13C98.5195 1658.24 97.9395 1657.74 97.8295 1656.67L97.3795 1652.3L100.969 1651.93L101.06 1652.79L98.4995 1653.05L98.6595 1654.63L100.969 1654.39L101.06 1655.26L98.7495 1655.5L98.8495 1656.49C98.9095 1657.06 99.1595 1657.29 99.6595 1657.24L101.539 1657.04L101.63 1657.9L99.5595 1658.13ZM95.7795 1658.53L95.1595 1652.54L96.1895 1652.43L96.8095 1658.42L95.7795 1658.53ZM94.2195 1643.55L95.2495 1643.44L95.8695 1649.43L94.8395 1649.54L94.2195 1643.55ZM92.6295 1657.03L91.7395 1657.12L91.9295 1658.92L90.8995 1659.03L90.2795 1653.04L92.3195 1652.83C93.6195 1652.69 94.3895 1653.29 94.5295 1654.66C94.6795 1656.08 93.9395 1656.89 92.6295 1657.03ZM87.8295 1659.35C86.7895 1659.46 86.2095 1658.96 86.0995 1657.89L85.6495 1653.52L89.2395 1653.15L89.3295 1654.01L86.7695 1654.28L86.9295 1655.86L89.2395 1655.62L89.3295 1656.49L87.0195 1656.73L87.1195 1657.72C87.1795 1658.29 87.4295 1658.52 87.9295 1658.47L89.8095 1658.27L89.8995 1659.13L87.8295 1659.35ZM83.5895 1659.85L83.3095 1659.88C81.5195 1660.07 80.3795 1659.11 80.2095 1657.47L80.1295 1656.73C79.9395 1654.93 81.1795 1653.93 82.8595 1653.75C83.4795 1653.69 84.1695 1653.75 84.5895 1653.87L84.6795 1654.72L84.6195 1654.73C84.1695 1654.63 83.4795 1654.57 82.9295 1654.63C81.8195 1654.74 81.0495 1655.35 81.1795 1656.63L81.2595 1657.37C81.3795 1658.52 82.1295 1659.14 83.2195 1659.02L83.4995 1658.99C83.7195 1658.97 83.9895 1658.91 84.1495 1658.84L84.0095 1657.51L82.9295 1657.62L82.8395 1656.75L84.8595 1656.54L85.1495 1659.36C84.8995 1659.51 84.1995 1659.79 83.5895 1659.85ZM76.7595 1651.41L76.1395 1645.42L76.9595 1645.33L80.2095 1649.12L79.7895 1645.04L80.8195 1644.93L81.4395 1650.92L80.5995 1651.01L77.3695 1647.22L77.7895 1651.3L76.7595 1651.41ZM75.3595 1660.71C73.6395 1660.89 72.6495 1659.93 72.4595 1658.11L72.4195 1657.72C72.2295 1655.93 73.0095 1654.78 74.7295 1654.6C76.4495 1654.42 77.4395 1655.35 77.6295 1657.18L77.6695 1657.57C77.8495 1659.35 77.0795 1660.53 75.3595 1660.71ZM67.9595 1661.41L67.9095 1660.88C68.6395 1659.71 69.9795 1657.22 70.3495 1655.98L67.5595 1656.27L67.4695 1655.41L71.5795 1654.98L71.6295 1655.46C71.2595 1656.68 69.9895 1659.24 69.2895 1660.4L72.1595 1660.1L72.2495 1660.96L67.9595 1661.41ZM66.2595 1646.57L69.8495 1646.2L69.9395 1647.06L67.3795 1647.33L67.5395 1648.91L69.8495 1648.67L69.9395 1649.54L67.6295 1649.78L67.7295 1650.77C67.7895 1651.34 68.0395 1651.57 68.5395 1651.52L70.4195 1651.32L70.5095 1652.18L68.4295 1652.4C67.3895 1652.51 66.8095 1652.01 66.6995 1650.94L66.2595 1646.57ZM75.0495 1645.54L75.1395 1646.4L72.5795 1646.67L72.7395 1648.25L75.0495 1648.01L75.1395 1648.88L72.8295 1649.12L72.9295 1650.11C72.9895 1650.68 73.2395 1650.91 73.7395 1650.86L75.6195 1650.67L75.7095 1651.53L73.6295 1651.74C72.5895 1651.85 72.0095 1651.35 71.8995 1650.28L71.4495 1645.91L75.0495 1645.54ZM86.0895 1644.39C87.3895 1644.26 88.1595 1644.85 88.2995 1646.22C88.4495 1647.64 87.6995 1648.45 86.3895 1648.59L85.4995 1648.68L85.6895 1650.48L84.6595 1650.59L84.0395 1644.6L86.0895 1644.39ZM91.0395 1643.88C92.3395 1643.74 93.0995 1644.18 93.2395 1645.56C93.3395 1646.52 92.9295 1647.04 92.3795 1647.39C93.1095 1647.91 93.8795 1649.13 94.0295 1649.56L94.0395 1649.62L92.9395 1649.73C92.7795 1649.29 92.0295 1648.15 91.4695 1647.8L90.4395 1647.91L90.6495 1649.97L89.6195 1650.08L88.9995 1644.09L91.0395 1643.88ZM103.789 1648.61L102.799 1648.71L102.7 1647.71L103.689 1647.61L103.789 1648.61ZM103.029 1642.64C104.139 1642.52 104.71 1642.93 104.81 1643.84C104.85 1644.25 104.699 1644.73 104.249 1645.39L103.56 1646.4L103.609 1646.91L102.619 1647.01L102.56 1646.47L103.38 1645.27C103.72 1644.78 103.859 1644.41 103.819 1644.05C103.769 1643.56 103.359 1643.46 102.819 1643.52L101.739 1643.63L101.649 1642.78L103.029 1642.64ZM115.679 1634.02L64.6195 1640.35C64.6195 1640.35 62.2495 1640.22 62.4695 1643.46L64.4595 1665.52C64.4595 1665.52 64.4595 1667.6 66.4895 1667.6L91.7495 1666.37L92.9595 1674.03C92.9595 1674.03 93.2695 1675.97 94.4595 1674.43L101.02 1665.92L112.819 1665.35C112.819 1665.35 114.849 1665.35 114.849 1663.27L118.299 1637.58C118.289 1637.57 119.279 1633.65 115.679 1634.02Z" fill="#EC008C"/>
      <path  d="M86.2499 1647.73C87.1399 1647.64 87.3399 1647.16 87.2499 1646.33C87.1599 1645.48 86.8599 1645.18 86.0299 1645.27L85.1699 1645.36L85.4199 1647.82L86.2499 1647.73Z" fill="#EC008C"/>
      <path  d="M76.341 1690.31L75.6836 1689.65L66.8764 1698.45L67.5338 1699.11L76.341 1690.31Z" fill="white"/>
      <path  d="M90.4799 1680.77L85.2299 1675.52C84.8999 1675.19 84.8999 1674.66 85.2299 1674.34C85.5599 1674.01 86.0899 1674.01 86.4099 1674.34L91.6599 1679.59C91.9899 1679.92 91.9899 1680.45 91.6599 1680.77C91.3299 1681.1 90.7999 1681.1 90.4799 1680.77Z" fill="white"/>
      <path  d="M94.1108 1677.14L88.8608 1671.89C88.5308 1671.56 88.5308 1671.03 88.8608 1670.71C89.1908 1670.38 89.7208 1670.38 90.0408 1670.71L95.2908 1675.96C95.6208 1676.29 95.6208 1676.82 95.2908 1677.14C94.9708 1677.46 94.4408 1677.46 94.1108 1677.14Z" fill="white"/>
      <path  d="M86.9502 1679.05C86.4802 1678.58 86.4802 1677.82 86.9502 1677.35L90.4502 1673.85C90.9202 1673.38 91.6802 1673.38 92.1502 1673.85C92.6202 1674.32 92.6202 1675.08 92.1502 1675.55L88.6502 1679.05C88.1802 1679.52 87.4102 1679.52 86.9502 1679.05Z" fill="white"/>
      <path  d="M71.6005 1694.39C71.1305 1693.92 71.1305 1693.16 71.6005 1692.69L75.9106 1688.38C76.3806 1687.91 77.1405 1687.91 77.6105 1688.38C78.0805 1688.85 78.0805 1689.61 77.6105 1690.08L73.3006 1694.39C72.8406 1694.86 72.0705 1694.86 71.6005 1694.39Z" fill="white"/>
      <path  d="M78.5703 1687.07C78.3303 1686.83 78.3303 1686.43 78.5703 1686.18C78.8103 1685.94 79.2103 1685.94 79.4603 1686.18L82.1503 1688.87L83.3103 1687.7L80.6203 1685.01C80.3803 1684.77 80.3803 1684.37 80.6203 1684.12C80.8603 1683.88 81.2603 1683.88 81.5103 1684.12L84.2003 1686.81L85.3703 1685.65L82.6803 1682.96C82.4403 1682.72 82.4403 1682.32 82.6803 1682.07C82.9203 1681.83 83.3203 1681.83 83.5703 1682.07L86.2603 1684.76L87.4203 1683.59L84.7303 1680.9C84.4903 1680.66 84.4903 1680.26 84.7303 1680.01C84.9703 1679.77 85.3703 1679.77 85.6203 1680.01L88.3103 1682.7L90.4403 1680.57L85.4103 1675.54L70.3203 1690.63L75.3503 1695.66L81.2703 1689.74L78.5703 1687.07Z" fill="white"/>
      <path  d="M76.2184 1684.75L70.3184 1690.65L75.3584 1695.7L81.2684 1689.79" fill="#00AEEF"/>
    </g>
   
        </>
    )
}




